import {
  ActionButton,
  Dialog,
  DialogCloseX,
  DialogHeading,
  DialogBody,
  DialogContent,
  DialogButtons,
  DialogButton,
  DialogTrigger,
  useToasterContext,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"

import { usePolyglot } from "src/contexts"
import { useDeleteAccount } from "src/hooks"
import { DeleteAccountErrorToast } from "src/toasts"

const polyglotPrefix = "pages.account.account_details.delete_account."

export function DeleteAccount() {
  const polyglot = usePolyglot()
  const deleteAccount = useDeleteAccount()
  const { showToast } = useToasterContext()

  const onDeleteClick = useCallback(
    () => {
      void (async () => {
        try {
          if (!deleteAccount) {
            throw new Error("cannot delete account")
          }

          await deleteAccount()
        } catch {
          showToast(
            "delete-account-error-toast",
            DeleteAccountErrorToast,
          )
        }
      })()
    },
    [
      deleteAccount,
      showToast,
    ],
  )

  return (
    <Dialog>
      <DialogTrigger asChild>
        <ActionButton
          stylePreset="destructive"
          id="delete-account-btn"
        >
          {polyglot.t(`${polyglotPrefix}trigger_cta`)}
        </ActionButton>
      </DialogTrigger>
      <DialogContent>
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}title`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogBody>
          {polyglot.t(`${polyglotPrefix}description`)}
        </DialogBody>
        <DialogButtons>
          <DialogButton
            id="confirm-delete"
            stylePreset="destructive"
            onClick={onDeleteClick}
            disabled={!deleteAccount}
          >
            {polyglot.t(`${polyglotPrefix}confirm_cta`)}
          </DialogButton>
          <DialogButton id="Cancel">
            {polyglot.t(`${polyglotPrefix}cancel_cta`)}
          </DialogButton>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}
